import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationItem from './NotificationItem';
import CustomScrollbars from 'util/CustomScrollbars';

class AppNotification extends React.Component {
    render() {
        const { notifications } = this.props;
        return (
            <CustomScrollbars className="messages-list scrollbar" style={{ height: 280 }}>
                <ul className="list-unstyled">
                    {notifications.map((notification, index) => <NotificationItem key={index}
                        notification={notification} />)
                    }
                </ul>
            </CustomScrollbars>
        );
    }
}

const mapStateToProps = ({ emps }) => {
    const { notifications } = emps;
    return { notifications };
};

export default withRouter(connect(mapStateToProps, null)(AppNotification));




// WEBPACK FOOTER //
// ./components/AppNotification/index.js